import Head from "next/head"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import Footer from "../../../../src/components/layout/landing/desktop/footer"
import Header from "../../../components/layout/landing/desktop/app-bar"

// Mui
import {
  Box,
  Chip,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme
} from "@mui/material"
import CustomIconWithText from "../../../components/pages/merchantDetails/components/CustomIconWithText"
//------------------------------------------------------
import Image from "next/image"
import NoImage from "public/noImages.png"
import { useIsMobileHandler } from "../../../hooks/useIsMobileHandler"
import axios from "../../../lib/axios"
//----------------------------------------------------------

type Status = "done" | "pending" | "error"

function MerchantId() {
  const theme = useTheme()
  const [merchantData, setMerchantData] = useState<any>({})
  const [isDataFound, setIsDataFound] = useState<Status>("done")
  const isMobile = useIsMobileHandler()

  const { query } = useRouter()
  const itemId = +query.id
  const handleFetchData = async () => {
    const { data } = await axios.get(`/api/v1/merchant/GetMerchant?Id=${itemId}`)
    if (data.succeed) {
      setMerchantData(data.value)
      setIsDataFound("done")
    } else {
      setIsDataFound("error")
    }
  }
  useEffect(() => {
    if (itemId) {
      setIsDataFound("pending")
      handleFetchData()
    }
  }, [itemId])
  if (!isMobile) {
    return (
      <>
        <Header isOtherPages={true} />
        <Head>
          <title>مشخصات پذیرنده</title>
        </Head>
        {/* <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
          <Typography variant='h3' fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
            مشخصات پذیرنده
          </Typography>
        </Stack> */}
        <Container
          sx={{
            padding: "1rem",
            mb: 6,
            pb: 2,
            bgcolor: "#ebebeb",
            borderRadius: "1rem",
            display: { xs: "block", md: "block", lg: "block", xl: "block" }
          }}
          id='acceptors'
        >
          {isDataFound === "done" ? (
            <>
              <Box>
                <Grid container item sx={{ mt: 3 }} md={12} alignItems='center' justifyContent='center'>
                  <Grid item sm={2} md={2.5}>
                    {merchantData?.logo ? (
                      <Image
                        width='200'
                        height='200'
                        style={{
                          borderRadius: "1.5rem",
                          boxShadow: "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px"
                          // border: "5px solid #000"
                        }}
                        src={merchantData?.logo}
                        alt={merchantData?.name}
                      />
                    ) : (
                      <Image
                        width='200'
                        height='160'
                        style={{
                          borderRadius: "1.5rem",
                          boxShadow: "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px"
                          // border: "5px solid #000"
                        }}
                        src={NoImage}
                        alt={merchantData?.name}
                      />
                    )}
                  </Grid>
                  <Grid item justifyContent='center'>
                    <Box display='flex' flexDirection='column'>
                      <Typography variant='h2' fontWeight='bold' color='primary' sx={{ marginBottom: 1 }}>
                        {merchantData?.name}
                      </Typography>
                      {merchantData?.siteAddress ? (
                        <Stack
                          spacing={1}
                          mt={2}
                          sx={{ cursor: "pointer", color: theme.palette.primary.main }}
                          onClick={() => {
                            const siteUrl = merchantData?.siteAddress
                              ? merchantData.siteAddress.startsWith("https://")
                                ? merchantData.siteAddress
                                : `https://${merchantData.siteAddress}`
                              : null;
                            if (siteUrl) {
                              window.open(siteUrl, "_blank")
                            }
                          }}
                        >
                          <Stack direction='row' spacing={1}>
                            <Chip
                              label={
                                <Typography>
                                  آدرس سایت:{" "}
                                  <span style={{ fontWeight: "bold" }}>{merchantData?.siteAddress || "N/A"}</span>
                                </Typography>
                              }
                              sx={{
                                color: "#1e1e1e",
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
                                backgroundColor: "#efefef",
                                borderRadius: "0.5rem" // Adjust border radius
                              }}
                            />
                          </Stack>
                        </Stack>
                      ) : null}
                      {merchantData?.storeType ? (
                        <Stack spacing={1} mt={2} sx={{ cursor: "pointer", color: theme.palette.primary.main }}>
                          <Stack direction='row' spacing={1}>
                            <Chip
                              label={
                                <Typography>
                                  نوع فروشگاه:{" "}
                                  <span style={{ fontWeight: "bold" }}>{merchantData?.storeType || "N/A"}</span>
                                </Typography>
                              }
                              sx={{
                                color: "#1e1e1e",
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
                                backgroundColor: "#efefef",
                                borderRadius: "0.5rem" // Adjust border radius
                              }}
                            />
                          </Stack>
                        </Stack>
                      ) : null}
                      <Box display={"flex"} mt={2} maxWidth={"100%"}>
                        <Grid container spacing={1}>
                          {merchantData.classOfActivity?.map((x, index) => (
                            <Grid item key={index}>
                              <Chip
                                label={x}
                                sx={{
                                  color: theme.palette.primary.main,
                                  fontWeight: "bold",
                                  boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
                                  backgroundColor: "#efefef",
                                  borderRadius: "0.5rem" // Adjust border radius
                                }}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              {merchantData ? <CustomIconWithText data={merchantData} /> : null}
              {merchantData?.branches && merchantData?.branches.length ? (
                <Grid container sx={{ mt: 3 }} alignItems='center' justifyContent='center'>
                  <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        minWidth: "50vw",
                        display: "flex",
                        justifyContent: "center",
                        width: "fit-content"
                      }}
                    >
                      <Table aria-label='simple table'>
                        <TableHead>
                          <TableRow>
                            <TableCell className='ratesTh' align='center'>
                              استان
                            </TableCell>
                            <TableCell className='ratesTh' align='center'>
                              شهر
                            </TableCell>
                            <TableCell className='ratesTh' align='center'>
                              شماره تماس
                            </TableCell>
                            <TableCell className='ratesTh' align='center'>
                              آدرس
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {merchantData?.branches?.map(x => (
                            <TableRow
                              key={x.id}
                              className='ratesTr'
                              sx={{ "&:last-child , &:last-child": { border: 0 } }}
                            >
                              <TableCell className='ratesTd' align='center'>
                                {x.province ? x.province : "-"}
                              </TableCell>
                              <TableCell className='ratesTd' align='center'>
                                {x.city ? x.city : "-"}
                              </TableCell>
                              <TableCell className='ratesTd' align='center'>
                                {[x.phoneNumber1, x.phoneNumber2, x.phoneNumber3].filter(Boolean).map((phone, i) => (
                                  <span
                                    style={{
                                      backgroundColor: "#eee",
                                      margin: " 0 0.5rem",
                                      padding: "0.5rem",
                                      borderRadius: "4px"
                                    }}
                                    key={i}
                                  >
                                    {phone}
                                  </span>
                                ))}
                              </TableCell>
                              <TableCell className='ratesTd' align='center'>
                                {x.address ? x.address : "-"}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </Grid>
              ) : null}
            </>
          ) : isDataFound === "error" ? (
            <Grid container sx={{ mt: 3 }} alignItems='center' justifyContent='center'>
              <Typography
                variant='h3'
                fontWeight='bold'
                sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}
              >
                مشخصات پذیرنده یافت نشد!
              </Typography>
            </Grid>
          ) : (
            <Grid container sx={{ mt: 3 }} alignItems='center' justifyContent='center'>
              <CircularProgress color='primary' />
            </Grid>
          )}
        </Container>

        <Footer />
      </>
    )
  } else {
    return (
      <>
        <Header isOtherPages={true} />
        <Head>
          <title>مشخصات پذیرنده</title>
        </Head>
        {/* <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
          <Typography variant='h3' fontWeight='bold' sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}>
            مشخصات پذیرنده
          </Typography>
        </Stack> */}
        <Container
          sx={{
            padding: "1rem",
            mb: 6,
            pb: 2,
            bgcolor: "#ebebeb",
            borderRadius: "1rem",
            display: { xs: "block", md: "block", lg: "block", xl: "block" }
          }}
          id='acceptors'
        >
          {isDataFound === "done" ? (
            <>
              <Grid container sx={{ mt: 3 }} alignItems='center' justifyContent='center'>
                {merchantData?.logo ? (
                  <Image
                    width='150'
                    height='150'
                    style={{
                      borderRadius: "1.5rem",
                      boxShadow: "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px"
                      // border: "5px solid #000"
                    }}
                    src={merchantData?.logo}
                    alt={merchantData?.name}
                  />
                ) : (
                  <Image
                    width='150'
                    height='150'
                    style={{
                      borderRadius: "1.5rem",
                      boxShadow: "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px"
                      // border: "5px solid #000"
                    }}
                    src={NoImage}
                    alt={merchantData?.name}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={8} justifyContent='center'>
                <Box display='flex' flexDirection='column' textAlign='center'>
                  <Typography variant='h2' fontWeight='bold' color='primary' sx={{ marginBottom: 1, mt: 2 }}>
                    {merchantData?.name}
                  </Typography>
                  {merchantData?.siteAddress ? (
                    <Stack
                      spacing={1}
                      mt={2}
                      sx={{ cursor: "pointer", color: theme.palette.primary.main }}
                      onClick={() => {
                        if (merchantData?.siteAddress) {
                          window.open(merchantData?.siteAddress, "_blank")
                        }
                      }}
                    >
                      <Chip
                        label={
                          <Typography>
                            آدرس سایت: <span style={{ fontWeight: "bold" }}>{merchantData?.siteAddress || "N/A"}</span>
                          </Typography>
                        }
                        sx={{
                          color: "#1e1e1e",
                          boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
                          backgroundColor: "#efefef",
                          borderRadius: "0.5rem"
                        }}
                      />
                    </Stack>
                  ) : null}
                  {merchantData?.storeType ? (
                    <Stack
                      spacing={1}
                      mt={2}
                      sx={{ cursor: "pointer", color: theme.palette.primary.main }}
                      onClick={() => {
                        if (merchantData?.storeType) {
                          window.open(merchantData?.storeType, "_blank")
                        }
                      }}
                    >
                      <Chip
                        label={
                          <Typography>
                            نوع فروشگاه: <span style={{ fontWeight: "bold" }}>{merchantData?.storeType || "N/A"}</span>
                          </Typography>
                        }
                        sx={{
                          color: "#1e1e1e",
                          boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
                          backgroundColor: "#efefef",
                          borderRadius: "0.5rem"
                        }}
                      />
                    </Stack>
                  ) : null}
                  <Box display={"flex"} mt={2} maxWidth={"100%"}>
                    <Grid container spacing={1}>
                      {merchantData.classOfActivity?.map((x, index) => (
                        <Grid item key={index}>
                          <Chip
                            label={x}
                            sx={{
                              color: theme.palette.primary.main,
                              fontWeight: "bold",
                              boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
                              backgroundColor: "#efefef",
                              borderRadius: "0.5rem"
                            }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Box>
              </Grid>

              {merchantData ? <CustomIconWithText data={merchantData} /> : null}
              {merchantData?.branches && merchantData?.branches.length ? (
                <Grid container sx={{ mt: 3 }} alignItems='center' justifyContent='center'>
                  <div style={{ width: "100%", overflowX: "auto" }}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        borderRadius: "8px",
                        overflowX: "auto"
                      }}
                    >
                      <Table aria-label='simple table'>
                        <TableHead>
                          <TableRow>
                            <TableCell className='ratesTh' align='center'>
                              استان
                            </TableCell>
                            <TableCell className='ratesTh' align='center'>
                              شهر
                            </TableCell>
                            <TableCell className='ratesTh' align='center'>
                              شماره تماس
                            </TableCell>
                            <TableCell className='ratesTh' align='center'>
                              آدرس
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {merchantData?.branches?.map((x, index) => (
                            <TableRow
                              key={index}
                              className='ratesTr'
                              sx={{ "&:last-child , &:last-child": { border: 0 } }}
                            >
                              <TableCell className='ratesTd' align='center'>
                                {x.province ? x.province : "-"}
                              </TableCell>
                              <TableCell className='ratesTd' align='center'>
                                {x.city ? x.city : "-"}
                              </TableCell>
                              <TableCell className='ratesTd' align='center'>
                                {[x.phoneNumber1, x.phoneNumber2, x.phoneNumber3].filter(Boolean).map((phone, i) => (
                                  <span
                                    style={{
                                      backgroundColor: "#eee",
                                      margin: "0.5rem 0",
                                      padding: "0.5rem",
                                      borderRadius: "4px",
                                      display: "block"
                                    }}
                                    key={i}
                                  >
                                    {phone}
                                  </span>
                                ))}
                              </TableCell>
                              <TableCell className='ratesTd' align='center'>
                                {x.address ? x.address : "-"}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </Grid>
              ) : null}
            </>
          ) : isDataFound === "error" ? (
            <Grid container sx={{ mt: 3 }} alignItems='center' justifyContent='center'>
              <Typography
                variant='h3'
                fontWeight='bold'
                sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}
              >
                مشخصات پذیرنده یافت نشد!
              </Typography>
            </Grid>
          ) : (
            <Grid container sx={{ mt: 3 }} alignItems='center' justifyContent='center'>
              <CircularProgress color='primary' />
            </Grid>
          )}
        </Container>

        <Footer />
      </>
    )
  }
}

export default MerchantId
